import { render } from "./BillingSection.vue?vue&type=template&id=4ee87f5c&scoped=true&ts=true"
import script from "./BillingSection.vue?vue&type=script&lang=ts"
export * from "./BillingSection.vue?vue&type=script&lang=ts"

import "./BillingSection.vue?vue&type=style&index=0&id=4ee87f5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee87f5c"]])

export default __exports__